export const SESSION_KEY = "session";
export const TV_TOKENS_KEY = "tvTokens";
export const CURRENT_SUB_PROFILE_ID_KEY = "currentSubprofileId";
export const DEVICE_KEY = "device";
export const PLAYER_SETTINGS_KEY = "nf_playerSettings";
export const PRODUCTS_KEY = "nf_products";
export const DUNNING_DIALOG_DISMISSED = "nf_dunningDialogDismissed";
export const SUBTITLE_SETTINGS = "subtitles";
